export default __webpack_public_path__ + "static/media/nineplus.f7becb7c.png";